module.exports = __webpack_public_path__ + "static/media/2 Black.83c3b6a3.svg";